module.exports = remotesConfig;